import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Params } from '@angular/router'

import { MetricUseCase } from 'src/app/modules/tools-catalogue/interfaces/metric-use-case.interface'
import { Metric } from 'src/app/modules/tools-catalogue/interfaces/metric.interface'
import { ToolUseCase } from 'src/app/modules/tools-catalogue/interfaces/tool-use-case.interface'
import { Tool } from 'src/app/modules/tools-catalogue/interfaces/tool.interface'
import { environment } from '../../../environments/environment'
import { InterGovernmentalOrganisation } from '../../modules/global-ai-db/interfaces/intergovernmental-organisation.interface'
import { Paginator } from '../interfaces/paginator.interface'
import { SelectOption } from '../interfaces/select-option.interface'

@Injectable({
  providedIn: 'root'
})
export class CatalogueService {
  constructor(private http: HttpClient) {}

  list(
    resourceName: string,
    refineParams?: Params
  ): Promise<
    | Tool[]
    | Paginator<Tool>
    | Metric[]
    | Paginator<Metric>
    | ToolUseCase[]
    | Paginator<ToolUseCase>
    | MetricUseCase[]
    | Paginator<MetricUseCase>
    | SelectOption[]
  > {
    let httpParams = new HttpParams()

    if (refineParams) {
      Object.keys(refineParams).forEach((key: string) => {
        if (Array.isArray(refineParams[key])) {
          refineParams[key].forEach((value: string) => {
            httpParams = httpParams.append(`${key}[]`, value)
          })
        } else {
          httpParams = httpParams.set(key, refineParams[key])
        }
      })
    }

    return this.http
      .get(`${environment.apiCatalogBaseUrl}${resourceName}`, {
        params: httpParams
      })
      .toPromise() as Promise<
      | Tool[]
      | Paginator<Tool>
      | Metric[]
      | Paginator<Metric>
      | ToolUseCase[]
      | Paginator<ToolUseCase>
      | MetricUseCase[]
      | Paginator<MetricUseCase>
      | SelectOption[]
    >
  }

  listSelectOptions(
    resourceName: string,
    refineParams?: object
  ): Promise<SelectOption[]> {
    return this.list(
      `taxonomies/${resourceName}/select-options`,
      refineParams
    ) as Promise<SelectOption[]>
  }

  show(
    resourceName: string,
    id: number | string,
    suffix?: string
  ): Promise<Tool | Metric | ToolUseCase | MetricUseCase> {
    return this.http
      .get(
        `${environment.apiCatalogBaseUrl}${resourceName}/${id}` +
          (suffix ? `/${suffix}` : '')
      )
      .toPromise() as Promise<Tool | Metric | ToolUseCase | MetricUseCase>
  }

  showBySlug(
    resourceName: string,
    slug: string
  ): Promise<
    Tool | Metric | ToolUseCase | MetricUseCase | InterGovernmentalOrganisation
  > {
    return this.http
      .get(`${environment.apiCatalogBaseUrl}${resourceName}/s/${slug}`)
      .toPromise() as Promise<Tool | Metric | ToolUseCase | MetricUseCase>
  }

  store(resourceSlug: string, resourceDto: any): Promise<any> {
    return this.http
      .post(
        `${environment.apiCatalogBaseUrl}${resourceSlug}/submit`,
        resourceDto
      )
      .toPromise()
  }
}
